import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t;

import { useSelector } from 'react-redux';
import styled from 'styled-components';
import UIFlex from 'UIComponents/layout/UIFlex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UICardGrid from 'UIComponents/card/UICardGrid';
import SplashPageCard from '../SplashPageCard';
import { currentOrderedPaidProductLevels } from 'self-service-api/constants/ProductLevels';
import { AllProductLines } from 'self-service-api/constants/ProductLines';
import { ProductLinePageIcons } from 'ui-addon-upgrades/_core/productPage/ProductPageIcons';
import breakpoint from 'pricing-pages-ui/constants/Breakpoints';
import { Section, Container, SectionHeader, SectionTitle, SectionSubTitle, IconImage, ProductLineIcon } from '../SplashPageSharedComponents';
import { STARTER, tabIdToProductLevels } from 'pricing-pages-ui/constants/routing/Tabs';
import StarterCrmSuiteCard from './StarterCrmSuiteCard';
import { isAppAuthSelector } from '../../../selectors/AuthSelectors';
import { SPLASH_PAGE_CARD } from '../../../constants/tracking/Locations';
import StarterCrmSuiteCtaCardGWP from '../../product-pages/StarterCrmSuiteCtaCardGWP';
import { isAnyStarterGWP2023EligibleSelector } from '../../../selectors/PromotionSelectors';
const ProductLineIconsContainer = styled(UIFlex).withConfig({
  displayName: "SuiteSection__ProductLineIconsContainer",
  componentId: "j0bj23-0"
})(["flex-wrap:wrap;max-width:100%;text-align:center;justify-content:center;margin-bottom:24px;> *{width:auto;}", ""], breakpoint.phoneLarge(_t || (_t = _`
    display: none;
  `)));

const SuiteSection = ({
  selectedTab,
  sectionProps
}) => {
  const isAppAuth = useSelector(isAppAuthSelector);
  const isEligibleForStarterGWPPromotion = useSelector(isAnyStarterGWP2023EligibleSelector);
  const isStarterGWP = isEligibleForStarterGWPPromotion;
  const productLevelTiles = currentOrderedPaidProductLevels.map(productLevel => {
    const suiteTabFromProductLevel = Object.keys(tabIdToProductLevels).find(tabId => tabIdToProductLevels[tabId].includes(productLevel));
    return /*#__PURE__*/_jsx(SplashPageCard, {
      titleKey: `splash-page.bundles.${productLevel}.title`,
      descriptionKey: `splash-page.bundles.${productLevel}.description`,
      showIcon: false,
      pathname: isAppAuth ? '/suite' : `/suite/${suiteTabFromProductLevel}`,
      trackingSource: `${productLevel.toLowerCase()}-${SPLASH_PAGE_CARD}`
    }, productLevel);
  });
  const productLineIcons = AllProductLines.map(productLine => {
    return /*#__PURE__*/_jsxs(ProductLineIcon, {
      children: [/*#__PURE__*/_jsx(IconImage, {
        className: "display-inline m-right-3",
        src: ProductLinePageIcons[productLine]
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: `splash-page.products.${productLine}.title`
      })]
    }, productLine);
  });
  return /*#__PURE__*/_jsx(Section, Object.assign({}, sectionProps, {
    children: /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsxs(SectionHeader, {
        children: [/*#__PURE__*/_jsx(SectionTitle, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `splash-page.bundles.title.${selectedTab}`
          })
        }), /*#__PURE__*/_jsx(SectionSubTitle, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `splash-page.bundles.subtitle.${selectedTab}`
          })
        }), !isStarterGWP && /*#__PURE__*/_jsx(ProductLineIconsContainer, {
          children: productLineIcons
        })]
      }), selectedTab === STARTER ? isStarterGWP ? /*#__PURE__*/_jsx(StarterCrmSuiteCtaCardGWP, {}) : /*#__PURE__*/_jsx(StarterCrmSuiteCard, {}) : /*#__PURE__*/_jsx(UICardGrid, {
        children: productLevelTiles
      })]
    })
  }));
};

export default SuiteSection;